import { GUIDE_TOUR_BLOCKED_TARGET_INTERACTION_MESSAGE_LINES } from '../types'
import { GuideTourStepCardBody } from './GuideTourStepCardBody'
import { GuideTourStepCardFooter } from './GuideTourStepCardFooter'
import { GuideTourStepCardHeader } from './GuideTourStepCardHeader'
import { useGuideTourStepCardModel } from './useGuideTourStepCardModel'
import * as S from './styles'

/** When `true`, hides badge and full header chrome; step label stays above the title. */
const hiddenHeader = true

export const GuideTourStepCardView = () => {
  const model = useGuideTourStepCardModel()

  if (!model) {
    return null
  }

  const {
    cardRef,
    top,
    left,
    arrowSide,
    isInModalLayer,
    isSummaryOnly,
    isTourUnavailablePage,
    currentStep,
    currentStepNumber,
    stepCount,
    isFirstStep,
    continueLabel,
    routeTourQueue,
    skippedStepNoticeMessage,
    isBlockedTargetInteractionWarningVisible,
    blockedTargetInteractionFeedbackKey,
    handleSkip,
    handleNext,
    handlePrev,
    cardSize,
  } = model

  let ariaLabelledBy = 'guide-tour-step-title'
  if (isTourUnavailablePage) {
    ariaLabelledBy = 'guide-tour-unavailable-title'
  } else if (isSummaryOnly) {
    ariaLabelledBy = 'guide-tour-skipped-summary-title'
  }

  let ariaDescribedBy: string | undefined = 'guide-tour-step-body'
  if (isTourUnavailablePage) {
    ariaDescribedBy = undefined
  } else if (isSummaryOnly) {
    ariaDescribedBy = 'guide-tour-skipped-step-notice'
  }

  return (
    <S.Card
      ref={cardRef}
      elevated={isInModalLayer}
      $arrowSide={arrowSide}
      $cardSize={cardSize}
      data-testid="guide-tour-step-card"
      data-size={cardSize}
      role="dialog"
      aria-labelledby={ariaLabelledBy}
      aria-describedby={ariaDescribedBy}
      style={{ top, left }}
      onClick={event => {
        event.stopPropagation()
      }}
      onKeyDown={event => {
        event.stopPropagation()
      }}
    >
      <S.CardInner $cardSize={cardSize}>
        {hiddenHeader && skippedStepNoticeMessage && !isTourUnavailablePage ? (
          <S.SkippedStepInfoNotice
            data-testid="guide-tour-skipped-step-notice"
            id="guide-tour-skipped-step-notice"
            role="status"
          >
            <span>
              {isSummaryOnly ? (
                <span id="guide-tour-skipped-summary-title">
                  {skippedStepNoticeMessage}
                </span>
              ) : (
                skippedStepNoticeMessage
              )}
            </span>
          </S.SkippedStepInfoNotice>
        ) : null}

        {hiddenHeader && isBlockedTargetInteractionWarningVisible ? (
          <S.BlockedInteractionDangerNotice
            data-testid="guide-tour-blocked-interaction-warning"
            role="alert"
          >
            {GUIDE_TOUR_BLOCKED_TARGET_INTERACTION_MESSAGE_LINES.map(line => (
              <span key={line}>{line}</span>
            ))}
          </S.BlockedInteractionDangerNotice>
        ) : null}

        <GuideTourStepCardHeader
          hiddenHeader={hiddenHeader}
          currentStep={currentStep}
          currentStepNumber={currentStepNumber}
          stepCount={stepCount}
          isSummaryOnly={isSummaryOnly}
          isTourUnavailablePage={isTourUnavailablePage}
          routeTourQueue={routeTourQueue}
          skippedStepNoticeMessage={skippedStepNoticeMessage}
          isBlockedTargetInteractionWarningVisible={
            isBlockedTargetInteractionWarningVisible
          }
          cardSize={cardSize}
          onDismiss={handleSkip}
        />

        <GuideTourStepCardBody
          currentStep={currentStep}
          isSummaryOnly={isSummaryOnly}
          isTourUnavailablePage={isTourUnavailablePage}
          unavailableMessage={
            isTourUnavailablePage ? skippedStepNoticeMessage : null
          }
          cardSize={cardSize}
        />

        <GuideTourStepCardFooter
          continueLabel={continueLabel}
          isFirstStep={isFirstStep}
          isSummaryOnly={isSummaryOnly}
          blockedTargetInteractionFeedbackKey={
            blockedTargetInteractionFeedbackKey
          }
          onNext={handleNext}
          onPrev={handlePrev}
        />
      </S.CardInner>
    </S.Card>
  )
}
